var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 61,
    viewBox: "0 0 107 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1671_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1808 7.82275H27.6672",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4075 53.425H16.4638C16.4638 53.5939 16.4075 53.791 16.4075 53.9599C16.4075 57.2252 19.0535 59.8713 22.3189 59.8713H84.3323C87.5976 59.8713 90.2437 57.2252 90.2437 53.9599C90.2437 53.7628 90.2155 53.5939 90.1874 53.425H90.2437",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2169 1.71436H22.3189C19.0535 1.71436 16.4075 4.36041 16.4075 7.62575C16.4075 7.68205 16.4075 7.7665 16.4075 7.8228V53.425H16.4638C16.7453 50.413 19.2506 48.0485 22.3189 48.0485H27.2169V1.71436Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2437 7.62575C90.2437 4.36041 87.5977 1.71436 84.3323 1.71436H79.4343V48.0766H84.3323C87.4006 48.0766 89.9059 50.4412 90.1874 53.4532H90.2437V7.8228C90.2437 7.8228 90.2437 7.68205 90.2437 7.62575Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7634 46.3032L43.8252 50.4411L44.0222 41.4051C44.0222 40.814 44.2193 40.2229 44.5289 39.7162L58.2659 18.1536C58.7163 17.4218 59.5326 16.9995 60.3771 16.9995H63.4454C64.4306 16.9995 65.3314 17.5907 65.7537 18.4914L66.9359 21.1656C67.2737 21.9257 67.2174 22.8265 66.767 23.5302L53.0019 45.1772C52.6923 45.6557 52.2701 46.0498 51.7352 46.3313L51.7634 46.3032Z",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3742 17.9567L50.3276 39.9977",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2981 45.2898L51.144 42.3623C50.6092 41.0393 49.3143 40.2229 47.9068 40.2792L44.6978 40.4481",
    stroke: "#C94B32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1671_1050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 61,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateProject);
export default __webpack_public_path__ + "static/media/createProject.361f65f435339a16cb58170139408874.svg";
export { ForwardRef as ReactComponent };